import { lazy } from "react";

export const AddToNicheSuccessPopup = lazy(() => import("./AddToNicheSuccessPopup"));
